import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import usePool from '@duckness/use-pool'
import InsightsDashboardPool from '@aytm/app/insights/dashboard/duckness/InsightsDashboardPool'
import SubjectSelector from '../SubjectSelector'
import { InvokeShareDialogButton } from '@aytm/app/insights/dashboard/components/sidebar/ShareDialog'
import { decode } from '@aytm/app/insights/dashboard/lib/sanitize'

import { stateSelector, shouldUpdate } from './selectors'

import classNames from 'classnames'
import mcss from './Header.module.scss'
import './Header.scss'

const CLASS = 'insights-portal-header'

const Header = props => {
  const className = props.className || CLASS

  const {
    decodedTitle,
    decodedSubtitle,
    currentSplit,
    wait,
    subjects,
    selectedSubjects,
    totalSubjects,
    totalRespondents,
    selectedRespondents
  } = usePool(InsightsDashboardPool, stateSelector, shouldUpdate)

  const filteredSubjects = useMemo(
    () => props.items.reduce((acc, item) => Object.assign(acc, { [item.uid]: subjects?.[item.uid] }), {}),
    [subjects, props.items]
  )

  const topic = props.topic ? <div className={mcss['topic']}>{decode(props.topic)}</div> : null

  const fullScreenClick = () => {
    if (props.onFullScreen) props.onFullScreen()
  }

  const refreshClick = event => {
    if (props.onRefresh) {
      const refresh = event?.shiftKey ? 'clean' : false
      props.onRefresh({ refresh })
    }
  }

  const subjectSelect = event => {
    if (props.onJump) props.onJump({ uid: event.uid })
  }

  const fullScreen = props.showFullScreen ? (
    <i className={`icon-aytmfd-full-screen ${className}-full-screen`} onClick={fullScreenClick} />
  ) : (
    <div className={`${className}-full-screen-empty`}></div>
  )

  const jumpTo = (
    <SubjectSelector
      className={`insights-portal-subject-selector-button ${className}-jump-to`}
      subjects={filteredSubjects}
      placeholder={`Jump to ${props.subjectType}`}
      keepEmpty={true}
      split={currentSplit}
      sort={true}
      icon={'pi pi-search'}
      onSelect={subjectSelect}
    />
  )

  const refreshIconClassName = `${className}-refresh-icon${wait ? ` ${className}-refresh-icon-wait` : ''}`
  const refresh = (
    <div className={`${className}-refresh`} onClick={refreshClick}>
      <i className={`icon-aytmfd-refresh ${refreshIconClassName}`}></i>
      <div className={`${className}-refresh-caption`}>Refresh</div>
    </div>
  )

  const style = props.blockWidth ? { width: `${props.blockWidth}px` } : null

  return (
    <div className={classNames(className, mcss['header'])} style={style}>
      <div className={classNames(mcss['first-row'], 'p-mb-2')}>
        <div className={mcss['title']} title={decodedTitle}>
          {decodedTitle}
        </div>
        <div className={mcss['row-right-side']}>
          {jumpTo}
          {refresh}
          {fullScreen}
        </div>
      </div>
      <div className={mcss['regular-row']}>
        <div className={classNames(mcss['subtitle'], 'p-mr-1')} title={decodedSubtitle}>
          {decodedSubtitle}
        </div>
        <div className="p-mr-1">{topic}</div>
        <div className={mcss['share-gear']}>
          <InvokeShareDialogButton />
        </div>
        <div className="p-mx-2">{' • '}</div>
        <div className={mcss['summary']}>
          <div className={mcss['summary-bold']}>{`${selectedSubjects.toLocaleString()}`}</div>
          <div className={mcss['summary-normal']}>{`/${totalSubjects.toLocaleString()}`}</div>
          <div className={mcss['summary-type']}>{`${props.subjectType}s | N=`}</div>
          <div className={mcss['summary-bold']}>{`${selectedRespondents.toLocaleString()}`}</div>
          <div className={mcss['summary-normal']}>{`/${totalRespondents.toLocaleString()}`}</div>
        </div>
      </div>
    </div>
  )
}

Header.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
  wait: PropTypes.any,
  exporting: PropTypes.any,
  subjectType: PropTypes.string,
  topic: PropTypes.any,
  showFullScreen: PropTypes.any,
  blockWidth: PropTypes.number,
  onFullScreen: PropTypes.func,
  onRefresh: PropTypes.func,
  onJump: PropTypes.func,
  onExport: PropTypes.func
}

Header.defaultProps = {
  showFullScreen: false,
  wait: false,
  subjectType: 'concept'
}

export default Header
